import React, { useState, useEffect, useCallback, useMemo } from "react";
import _ from "lodash";
import axios from "axios";
import { parse as queryStringParse } from "query-string";
import { useLocation, useHistory, useParams } from "react-router-dom";
import intersection from "lodash/intersection";
import { BookingForm } from "@witbooking/react-components";
import constants from "../../utils/constants";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { actions as appActions } from "../App";
import { selectors as reservationSelectors } from "../ReservationManager";
const appSelectors = require("../App/selectors");
import { bookingFormActions } from "../../redux/modules/bookingForm";
import { withRouter } from "react-router";
import styled from "styled-components";
import { submitBookingForm } from "./utils";
import { getLinkToLoyaltyLogin, redirectUrl, renderHTML } from "../../utils/misc";
import { useSelector } from "react-redux";
import {
  getFromSessionStorage,
  removeFromSessionStorage,
  removeFromLocalStorage,
} from "../../utils/misc";
import { format } from "date-fns";
import {
  bookingFormFieldsSelector,
  bookingFormInitialValuesSelector,
  bookingFormSelector,
} from "./selectors";
import get from "lodash/get";
import { useSessionData } from "../../utils/session";
import { useIntl, defineMessages, FormattedMessage } from "react-intl";
import { currencySelector } from "../App/selectors";

const msgs = defineMessages({
  textNoOption: {
    id: "booking_form.custom_select.noOptions",
    description: "No options",
    defaultMessage: "No options",
  },
});

const selectors = { ...appSelectors, ...reservationSelectors };

const DefaultMenu = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 35px;
  position: relative;
`;
const DefaultMenuLogo = styled.div`
  position: absolute;
  top: 50px;
`;

const ImageMenuLogo = styled.img`
  max-width: 220px;
  max-height: 200px;
`;

function BookingFormWrapper(props) {
  const {
    initialValues,
    menuMarkup,
    menuButtonMarkup,
    showMenu,
    showBookingForm,
    isWithotel,
    ariLoading,
    changeConfiguration,
    addAlert,
    requestARI,
    handleModalContent,
    handleCloseModal,
    handleWithotelMenu,
    currentStep,
    isBookingFormSummaryOpened,
    toggleBookingFormSummary,
    fields,
    theme,
    bookingFormChanged,
    loyaltyUser,
    encodedAffiliate,
    showBackArrow,
    myAccountClicked,
    myReservationsClicked,
  } = props;
  const push = props.history.push;
  const element = document.body;
  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [occupantInfo, setOccupantInfo] = useState({});
  const [resolution, setResolution] = useState(constants.RESOLUTION.XS);
  const [lastResolution, setLastResolution] = useState(resolution);
  const [logo, setLogo] = useState("");
  const [logoMobile, setLogoMobile] = useState("");
  const [deviceType, setDeviceType] = useState("");
  const [selectedFilterValue, setSelectedFilterValue] = useState({});
  const [form, setForm] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selectorMode, setSelectorMode] = useState("");
  const [urlFilter, setUrlFilter] = useState(null);
  const [establishmentFilter, setEstablishmentFilter] = useState(null);
  const [showMenuMarkup, setShowMenuMarkup] = useState(false);
  const [promoCodes, setPromoCodes] = useState("");
  const [lastValues, setLastValues] = useState({});
  const [promoCodesValue, setPromoCodesValue] = useState(
    get(restoredSession, "promoCodes", undefined) ? "" : undefined
  );
  const [lastScrollPosition, setLastScrollPosition] = useState(0);
  const [allowScroll, setAllowScroll] = useState(true);
  const [addPaddingToLogo, setAddPaddingToLogo] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const params = useParams();

  // Selectors
  const customStyles = useSelector(selectors.customStylesSelector);
  const propertyTabs = useSelector(selectors.propertyTabsSelector);
  const propertyActiveTab = useSelector(selectors.propertyActiveTabSelector);
  const propertyTicker = useSelector(selectors.propertyTickerSelector);
  const locale = useSelector(selectors.localeSelector);
  const startDate = useSelector(selectors.startDateSelector);
  const endDate = useSelector(selectors.endDateSelector);
  const promoCode = useSelector(selectors.promoCodeSelector);
  const bookingFormFields = useSelector(bookingFormFieldsSelector);
  const bookingFormInitialValues = useSelector(bookingFormInitialValuesSelector);
  const propertyFilters = useSelector(selectors.propertyFiltersSelector);
  const deviceInfo = useSelector(selectors.deviceInfoSelector);
  const propertyTickers = useSelector(selectors.propertyTickersSelector);
  const activeFilters = useSelector(selectors.activeFiltersSelector);
  const fullWidth = useSelector(selectors.fullWidthSelector);
  const logos = useSelector(selectors.logosSelector);
  const hotelSiteURL = useSelector(selectors.hotelSiteURLSelector);
  const showElementsConfig = useSelector(selectors.showElementsConfigSelector);
  const bookingForm = useSelector(bookingFormSelector);
  const roomDenomination = useSelector(selectors.roomDenominationSelector);
  const showMultipleAccommodations = useSelector(selectors.showMultipleAccommodationsSelector);
  const restoredSession = useSelector(selectors.restoredSessionSelector);
  const loyalty = useSelector(selectors.loyaltySelector);
  const brand = useSelector(selectors.brandSelector);
  const channel = useSelector(selectors.channelSelector);
  const origin = useSelector(selectors.originSelector);
  const affiliate = useSelector(selectors.affiliateSelector);
  const currency = useSelector(selectors.currencySelector);
  const globalPropertyTicker = propertyTicker;
  const session = useSessionData(null, null, true);
  const intl = useIntl();

  const linkToLogin = useMemo(() => {
    return getLinkToLoyaltyLogin({
      brand,
      propertyTicker,
      locale: intl.locale,
      queryParams: {
        datein: format(startDate, "dd-MM-yyyy"),
        dateout: format(endDate, "dd-MM-yyyy"),
        channel,
        origin,
        affiliate,
        setconversion: currency,
        locale: intl.locale,
        prom: promoCodes,
      },
      bookingFormInitialValues,
    });
  }, [
    promoCodes,
    brand && brand.ticker,
    propertyTicker,
    intl.locale,
    window.__additionalData.AUTH_URL,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    function handleResize() {
      initResolution();
    }
    if (_.isEmpty(form) && isLoading) {
      setTheme();
      setInitValues();
      setIsLoading(false);
      initResolution();
      setShowMenuMarkup(showMenu && ((menuMarkup && menuMarkup.get("code")) || isWithotel) && true);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [form, isLoading, setInitValues]);

  useEffect(() => {
    if (!_.isEqual(lastValues, bookingForm)) {
      setInitValues();
      setLastValues(bookingForm);
    }
  }, [bookingForm, lastValues]);

  useEffect(() => {
    if (startDate !== selectedStartDate) {
      setSelectedStartDate(startDate);
    }
    if (endDate !== selectedEndDate) {
      setSelectedEndDate(endDate);
    }
  }, [startDate, endDate, selectedStartDate, selectedEndDate]);

  useEffect(() => {
    const isAStickyResolution =
      resolution === constants.RESOLUTION.XXS || resolution === constants.RESOLUTION.MD;
    if (lastResolution !== resolution) {
      setLastResolution(resolution);
      if (lastScrollPosition > 0 && isAStickyResolution) {
        window.scrollTo(0, lastScrollPosition);
        setAllowScroll(false);
      }
    }
  }, [lastScrollPosition, resolution, lastResolution]);

  const handleHeaderMarkup = useCallback(display => {
    // there is a header markup
    const externalMarkupHeader = document.getElementById("wbk-HeaderExternal");
    if (externalMarkupHeader) {
      externalMarkupHeader.style.display = display;
    }
  }, []);

  useEffect(() => {
    const checkHeader = _.throttle(() => {
      const isAStickyResolution =
        resolution === constants.RESOLUTION.XXS || resolution === constants.RESOLUTION.MD;
      const scrollPosition = Math.round(window.scrollY);
      if (allowScroll) {
        if (scrollPosition === 0) {
          setStickyResolution(false);
          handleHeaderMarkup("block");
        } else if (!isAStickyResolution) {
          setLastScrollPosition(scrollPosition);
          setStickyResolution(true);
          handleHeaderMarkup("none");
        }
      } else {
        handleHeaderMarkup("none");
        setAllowScroll(true);
      }
    }, 300);

    window.addEventListener("scroll", checkHeader);
    return () => window.removeEventListener("scroll", checkHeader);
  }, [resolution, allowScroll]);

  function setTheme() {
    const logoBackgroundColor =
      (customStyles && "#" + customStyles.get("logoBackgroundColor")) || "unset";
    const backgroundColor = customStyles && "#" + customStyles.get("bookingFormBackgroundColor");
    const bookingFormOppositeColor =
      customStyles && "#" + customStyles.get("bookingFormOppositeColor");
    const bookingFormButtonBackgroundColor =
      customStyles && "#" + customStyles.get("bookingFormButtonBackgroundColor");
    const bookingFormButtonOppositeColor =
      customStyles && "#" + customStyles.get("bookingFormButtonOppositeColor");
    let borderColor = "rgb(255,255,255,0.5)";

    if (bookingFormOppositeColor === "#000000") {
      borderColor = "rgba(0, 0, 0, 0.5)";
    }
    theme.logo.backgroundColor = logoBackgroundColor;
    theme.menu.backgroundColor = backgroundColor;
    if (
      logoBackgroundColor !== backgroundColor &&
      !logoBackgroundColor.includes("undefined") &&
      !logoBackgroundColor.includes("unset") &&
      !backgroundColor.includes("undefined")
    ) {
      setAddPaddingToLogo(true);
    }
    theme.colorOpposite = bookingFormOppositeColor;
    theme.hover = {
      color: bookingFormOppositeColor,
      fill: bookingFormOppositeColor,
    };
    theme.button = {
      backgroundColor: bookingFormButtonBackgroundColor,
      color: bookingFormButtonOppositeColor,
    };
    theme[constants.DEVICE_TYPE.DESKTOP] = {
      ...theme[constants.DEVICE_TYPE.DESKTOP],
      code: {
        color: borderColor,
      },
      datePicker: {
        ...theme[constants.DEVICE_TYPE.DESKTOP].datePicker,
        color: bookingFormOppositeColor,
        borderBottom: `1px solid ${borderColor}`,
      },
      filter: {
        ...theme[constants.DEVICE_TYPE.DESKTOP].filter,
        color: bookingFormOppositeColor,
        borderColor,
        hover: {
          color: bookingFormOppositeColor,
          fill: bookingFormOppositeColor,
        },
      },
      occupant: {
        ...theme[constants.DEVICE_TYPE.DESKTOP].occupant,
        color: bookingFormOppositeColor,
        borderBottom: `1px solid ${borderColor}`,
      },
      svg: {
        fill: borderColor,
      },
    };
  }

  const setStickyResolution = useCallback(
    sticky => {
      let newResolution = constants.RESOLUTION.MD;
      const screenWidth = window.screen.availWidth;
      let newDeviceType = constants.DEVICE_TYPE.MOBILE;
      if (sticky) {
        if (screenWidth < constants.RESOLUTION.MD) {
          newResolution = constants.RESOLUTION.XXS;
        }
        if (
          newResolution === constants.RESOLUTION.MD ||
          newResolution === constants.RESOLUTION.LG
        ) {
          newDeviceType = constants.DEVICE_TYPE.DESKTOP;
        }
        if (newDeviceType !== deviceType) {
          setDeviceType(newDeviceType);
        }
        if (newResolution !== resolution) {
          setResolution(newResolution);
        }
      } else {
        initResolution();
      }
    },
    [resolution, deviceType]
  );

  function initResolution() {
    const screenWidth = window.screen.availWidth;
    let resolution;
    let deviceType = constants.DEVICE_TYPE.MOBILE;
    if (screenWidth <= constants.RESOLUTION.XXS) {
      resolution = constants.RESOLUTION.XXS;
    } else if (constants.RESOLUTION.XXS < screenWidth && screenWidth < constants.RESOLUTION.XS) {
      resolution = constants.RESOLUTION.XXS;
    } else if (constants.RESOLUTION.XS <= screenWidth && screenWidth < constants.RESOLUTION.SM) {
      resolution = constants.RESOLUTION.XS;
    } else if (constants.RESOLUTION.SM <= screenWidth && screenWidth < constants.RESOLUTION.MD) {
      resolution = constants.RESOLUTION.SM;
    } else if (constants.RESOLUTION.MD <= screenWidth && screenWidth < constants.RESOLUTION.LG) {
      resolution = constants.RESOLUTION.MD;
      deviceType = constants.DEVICE_TYPE.DESKTOP;
    } else {
      resolution = constants.RESOLUTION.LG;
      deviceType = constants.DEVICE_TYPE.DESKTOP;
    }
    setResolution(resolution);
    setDeviceType(deviceType);
  }

  function getOccupantObject(occupantType, constant, selectorsRange, value) {
    const length = selectorsRange[occupantType].length;
    const maxValue = selectorsRange[occupantType][length - 1];

    return {
      occupantType: constants.OCCUPANTS_TYPE[constant],
      minValue: selectorsRange[occupantType][0],
      maxValue,
      value: value > maxValue ? parseInt(maxValue) : parseInt(value),
    };
  }

  function getOccupantChildrenCountObject(selectorsRange, value) {
    const { childrenCount, childrenAges } = selectorsRange;

    return {
      ageRanges: {
        min: childrenAges.min,
        max: childrenAges.max,
      },
      occupantType: constants.OCCUPANTS_TYPE.CHILDREN,
      minValue: childrenCount.min,
      maxValue: childrenCount.max,
      value: parseInt(value),
    };
  }

  function getPromoCode() {
    return (
      (bookingForm.promoCodes && bookingForm.promoCodes.value) ||
      bookingFormInitialValues.promoCodes
    );
  }

  function getFilters() {
    return (bookingForm.filters && bookingForm.filters.value) || bookingFormInitialValues.filters;
  }

  const setInitValues = useCallback(() => {
    const promoCodes = getPromoCode();
    const newPromoCodesValue = get(restoredSession, "promoCodes", undefined) ? "" : undefined;
    const filters = getFilters();
    setPromoCodes(promoCodes);
    const { occupants, stayQueue } = setOccupants();
    setFilters(filters);
    if (newPromoCodesValue !== undefined) {
      setPromoCodesValue("");
    }
    const newForm = {
      ...form,
      promoCodes,
      occupants,
      stayQueue,
      filters,
      startDate,
      endDate,
    };
    setForm(newForm);
    bookingFormChanged({
      ...occupants,
      ...form,
    });
  }, []);

  function initialUrlFilter(propertyFilters) {
    const urlFilters =
      propertyFilters &&
      propertyFilters.filter(filter => {
        if (filter.get("options")) {
          const result = filter
            .get("options")
            .find(option => option && option.get("type") === constants.PROPERTY_FILTER.TYPE.URL);
          if (result) {
            return filter;
          }
        }
      });
    return urlFilters;
  }

  function getOccupantsValue() {
    const ADULT =
      bookingForm.ADULT && bookingForm.ADULT.value > -1
        ? bookingForm.ADULT.value
        : bookingFormInitialValues.ADULT;
    const BABY =
      bookingForm.BABY && bookingForm.BABY.value > -1
        ? bookingForm.BABY.value
        : bookingFormInitialValues.BABY;
    const CHILD =
      bookingForm.CHILD && bookingForm.CHILD.value > -1
        ? bookingForm.CHILD.value
        : bookingFormInitialValues.CHILD;
    const TEENAGER =
      bookingForm.TEENAGER && bookingForm.TEENAGER.value > -1
        ? bookingForm.TEENAGER.value
        : bookingFormInitialValues.TEENAGER;
    const SENIOR =
      bookingForm.SENIOR && bookingForm.SENIOR.value > -1
        ? bookingForm.SENIOR.value
        : bookingFormInitialValues.SENIOR;
    const childrenCount =
      bookingForm.childrenCount && bookingForm.childrenCount.value > -1
        ? bookingForm.childrenCount.value
        : bookingFormInitialValues.childrenCount;
    const guestAges = bookingForm.guestAges || bookingFormInitialValues.guestAges;
    return { ADULT, BABY, CHILD, TEENAGER, SENIOR, childrenCount, guestAges };
  }

  function getOccupantsFormatInStayQueue(occupants) {
    return (
      occupants &&
      Object.keys(occupants).reduce((result, occupantType) => {
        const data = occupants[occupantType];
        result = {
          ...result,
          [occupantType]: data.value,
        };
        if (data.guestAges) {
          result.guestAges = data.guestAges;
        }
        return result;
      }, {})
    );
  }

  function setOccupants() {
    let values = getOccupantsValue();
    let occupants;
    let stayQueue;
    const queue = getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE);
    const ages = getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE_AGES);
    const queueIndex = getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE_INDEX);
    if (
      bookingForm.stayQueue &&
      bookingForm.stayQueue.value &&
      queueIndex > -1 &&
      showMultipleAccommodations
    ) {
      stayQueue = bookingForm.stayQueue.value;
      const { childrenCount } = bookingFormFields.fields;
      if (childrenCount) {
        setSelectorMode(constants.OCCUPANTS_FILTER_TYPE.AGE);
      } else {
        setSelectorMode(constants.OCCUPANTS_FILTER_TYPE.OCCUPANTS_TYPE);
      }
      occupants = stayQueue;
      const index = Object.keys(occupants)[queueIndex];
      if (index) {
        values = getOccupantsFormatInStayQueue(occupants[index]);
      }
    } else if (queue && queue.length) {
      occupants = setOccupantsByStayQueue(queue, ages);
      const index = Object.keys(occupants)[queueIndex];

      if (occupants && index !== undefined) {
        values = getOccupantsFormatInStayQueue(occupants[index]);
        if (!showMultipleAccommodations) {
          occupants = {
            1: formatOccupants({ values }),
          };
        }
      }
    } else {
      occupants = {
        1: formatOccupants({ values }),
      };
    }
    setOccupantInfo(occupants);
    return { occupants: values, stayQueue };
  }

  function setOccupantsByStayQueue(stayQueue, ages) {
    const occupants = stayQueue.reduce((result, stay, index) => {
      const values = {
        ADULT: stay.adults,
        CHILD: stay.children,
        SENIOR: stay.seniors,
        TEENAGER: stay.teenagers,
        BABY: stay.babies,
      };
      if (Array.isArray(ages) && ages.length) {
        values.childrenCount = ages[index].length;
        values.guestAges = ages[index];
      }
      result = {
        ...result,
        [index]: {
          ...formatOccupants({ values }),
        },
      };
      return result;
    }, {});
    return occupants;
  }

  function formatOccupants({ values }) {
    let occupants = {};
    const { ageRanges, selectorsRange } = bookingFormFields;
    const {
      ADULT,
      BABY,
      CHILD,
      childrenCount,
      TEENAGER,
      SENIOR,
      guestAges,
    } = bookingFormFields.fields;
    const {
      ADULT: adultValue,
      BABY: babyValue,
      CHILD: childValue,
      TEENAGER: teenagerValue,
      SENIOR: seniorValue,
      guestAges: guestAgesValue,
      childrenCount: childrenCountValue,
    } = values;
    if (!_.isEmpty(selectorsRange)) {
      if (SENIOR && selectorsRange.SENIOR) {
        occupants = {
          ...occupants,
          [constants.OCCUPANTS_TYPE.SENIOR]: {
            ...getOccupantObject("SENIOR", "SENIOR", selectorsRange, seniorValue),
            ageRanges: ageRanges[constants.OCCUPANTS_TYPE.SENIOR],
          },
        };
      }
      if (ADULT && selectorsRange.ADULT) {
        occupants = {
          ...occupants,
          [constants.OCCUPANTS_TYPE.ADULT]: {
            ...getOccupantObject("ADULT", "ADULT", selectorsRange, adultValue),
            ageRanges: ageRanges[constants.OCCUPANTS_TYPE.ADULT],
          },
        };
      }
      if (TEENAGER && selectorsRange.TEENAGER) {
        occupants = {
          ...occupants,
          [constants.OCCUPANTS_TYPE.TEENAGER]: {
            ...getOccupantObject("TEENAGER", "TEENAGER", selectorsRange, teenagerValue),
            ageRanges: ageRanges[constants.OCCUPANTS_TYPE.TEENAGER],
          },
        };
      }
      if (CHILD && selectorsRange.CHILD) {
        occupants = {
          ...occupants,
          [constants.OCCUPANTS_TYPE.CHILDREN]: {
            ...getOccupantObject("CHILD", "CHILDREN", selectorsRange, childValue),
            ageRanges: ageRanges[constants.OCCUPANTS_TYPE.CHILDREN],
          },
        };
      }
      if (childrenCount) {
        occupants = {
          ...occupants,
          [constants.OCCUPANTS_TYPE.CHILDREN]: {
            ...getOccupantChildrenCountObject(selectorsRange, childrenCountValue || childValue),
            guestAges: guestAgesValue || guestAges || [],
          },
        };
        setSelectorMode(constants.OCCUPANTS_FILTER_TYPE.AGE);
      } else {
        setSelectorMode(constants.OCCUPANTS_FILTER_TYPE.OCCUPANTS_TYPE);
      }
      if (BABY && selectorsRange.BABY) {
        occupants = {
          ...occupants,
          [constants.OCCUPANTS_TYPE.BABY]: {
            ...getOccupantObject("BABY", "BABY", selectorsRange, babyValue),
            ageRanges: ageRanges[constants.OCCUPANTS_TYPE.BABY],
          },
        };
      }
    }

    if (!_.isEmpty(occupants)) {
      return occupants;
    }
    setSelectorMode(constants.OCCUPANTS_FILTER_TYPE.NONE);
  }

  // There are two kinds of filters: URL or Establishment. This function set the filter depends on it.
  const setFilters = useCallback(filters => {
    let filter = {};
    let optionByDefault = {};
    if (propertyFilters && bookingFormFields.fields.filters) {
      const establishment = initialEstablishmentFilter(
        propertyFilters,
        activeFilters,
        propertyTickers
      );
      const urlFilter = initialUrlFilter(propertyFilters);
      if (establishment && establishment.size) {
        filter = establishment.toJS()[0];
        optionByDefault = establishment.get(0).get("options").toJS()[0] || {};
        if (filters) {
          optionByDefault =
            establishment.toJS()[0].options.find(option => {
              return option.pattern === filters;
            }) || {};
          if (optionByDefault.optionName) {
            optionByDefault.name = optionByDefault.optionName;
          }
        }
        setSelectedFilterValue(optionByDefault);
        setEstablishmentFilter(filter);
        setFilterData(filter);
        setShowFilter(true);
      } else if (urlFilter && urlFilter.size) {
        filter = urlFilter.toJS()[0];
        if (filters) {
          optionByDefault = filter.options.find(option => {
            option.pattern === filters;
          });
        } else if (propertyTickers) {
          const propertyTickersString = propertyTickers && propertyTickers.join(",");
          optionByDefault = filter.options.find(option => {
            const pattern = option.pattern.split("hotel=") || [];
            return pattern.length && pattern[1] === propertyTickersString;
          });
        }
        if (_.isEmpty(optionByDefault)) {
          optionByDefault = filter.options[0] || {};
        }
        setSelectedFilterValue(optionByDefault || {});
        setUrlFilter(filter);
        setFilterData(filter);
        setShowFilter(true);
      }
    }
  }, []);

  const submitFormSearchButton = useCallback(
    ({ modifiedForm, establishmentFilter, urlFilter, selectedFilterValue, propertyTicker }) => {
      if (urlFilter && selectedFilterValue.optionTicker !== propertyTicker) {
        const queryParams =
          (location && location.search && queryStringParse(location.search)) || {};
        let filter = selectedFilterValue.pattern.split("?");
        let url = filter.shift();
        if (url && url.charAt(0) === "/") {
          const currentDomain = window
            ? `${window.location.protocol}//${window.location.host}`
            : "https://engine.witbooking.com";
          url = currentDomain + url;
        }
        let query = (filter && filter.join("?")) || null;
        let separator = "?";

        bookingFormChanged({
          ...modifiedForm,
        });
        if (query) {
          url += separator + query;
          separator = "&";
        }
        if (modifiedForm) {
          if (modifiedForm.occupants[constants.OCCUPANTS_TYPE.SENIOR]) {
            url += separator + "seniors=" + modifiedForm.occupants[constants.OCCUPANTS_TYPE.SENIOR];
            separator = "&";
          }

          if (modifiedForm.occupants[constants.OCCUPANTS_TYPE.ADULT]) {
            url += separator + "adults=" + modifiedForm.occupants[constants.OCCUPANTS_TYPE.ADULT];
            separator = "&";
          }

          if (modifiedForm.occupants[constants.OCCUPANTS_TYPE.TEENAGER]) {
            url +=
              separator + "teenagers=" + modifiedForm.occupants[constants.OCCUPANTS_TYPE.TEENAGER];
            separator = "&";
          }

          if (modifiedForm.occupants[constants.OCCUPANTS_TYPE.CHILDREN]) {
            url +=
              separator + "children=" + modifiedForm.occupants[constants.OCCUPANTS_TYPE.CHILDREN];
            separator = "&";
          }

          if (modifiedForm.occupants[constants.OCCUPANTS_TYPE.BABY]) {
            url += separator + "babies=" + modifiedForm.occupants[constants.OCCUPANTS_TYPE.BABY];
            separator = "&";
          }
          url += separator + "guestAges=" + (modifiedForm?.occupants?.guestAges?.join(",") || "");
          separator = "&";

          if (modifiedForm.startDate) {
            url += separator + "datein=" + format(modifiedForm.startDate, "dd-MM-yyyy");
            separator = "&";
          }

          if (modifiedForm.endDate) {
            url += separator + "dateout=" + format(modifiedForm.endDate, "dd-MM-yyyy");
            separator = "&";
          }

          if (modifiedForm.promoCodes) {
            url += separator + "prom=" + modifiedForm.promoCodes;
          }

          if (queryParams.affiliate) {
            url += separator + "affiliate=" + queryParams.affiliate;
          }
          if (encodedAffiliate) {
            url += separator + "encodedAffiliate=" + encodedAffiliate;
          }

          if (queryParams.tags) {
            url += separator + "tags=" + queryParams.tags;
          }

          if (queryParams.origin) {
            url += separator + "origin=" + queryParams.origin;
          }
        }

        redirectUrl(url);
        return;
      }

      const mergedFormValues = modifiedForm || {};

      if (establishmentFilter) {
        mergedFormValues.filters = establishmentFilter.pattern;
        mergedFormValues.propertyTickers = establishmentFilter && {
          [constants.PROPERTY_FILTER.HOTEL_FILTER]:
            establishmentFilter[constants.PROPERTY_FILTER.HOTEL_FILTER],
        };
        const arrList = Object.values(mergedFormValues.propertyTickers);
        mergedFormValues.propertyTickers = intersection(...arrList);
      }
      submitForm(mergedFormValues);
    },
    [establishmentFilter, urlFilter]
  );

  // This function set the establishment filter.
  function initialEstablishmentFilter(propertyFilters, activeFilters, propertyTickers) {
    let result = {};
    const propertyTickersString = propertyTickers && propertyTickers.join(",");
    const establishmentFilters =
      propertyFilters &&
      propertyFilters.filter(filter => {
        if (filter.get("options")) {
          return filter
            .get("options")
            .filter(
              option =>
                option && option.get("type") === constants.PROPERTY_FILTER.TYPE.ESTABLISHMENT
            );
        }

        return false;
      });

    // Setup option by default
    let optionByDefault =
      (establishmentFilters &&
        establishmentFilters.size &&
        establishmentFilters.get(0).get("options").toJS()[0]) ||
      {};

    // If there are activeFilters find the option by default
    if (activeFilters) {
      activeFilters.map(activeFilter => {
        const filterSplit = activeFilter.split(",");
        if (filterSplit) {
          const filter =
            establishmentFilters &&
            establishmentFilters.find(
              establishmentFilter => establishmentFilter.get("filterTicker") === filterSplit[0]
            );
          const optionFilter =
            filter &&
            filter.get("options") &&
            filter.get("options").find(option => option.get("optionTicker") === filterSplit[1]);
          if (optionFilter) {
            optionByDefault = {
              [filterSplit[0]]: optionFilter.get("pattern"),
              name: optionFilter.get("optionName"),
              optionTicker: optionFilter.get("optionTicker"),
            };
          }
        }
      });
    }

    // If there are propertyTickers find the option by default
    if (propertyTickersString) {
      const hotelFilter =
        establishmentFilters &&
        establishmentFilters.find(
          filter => filter.get("filterTicker") === constants.PROPERTY_FILTER.HOTEL_FILTER
        );
      if (hotelFilter && hotelFilter.get("options")) {
        result[constants.PROPERTY_FILTER.HOTEL_FILTER] = hotelFilter.get("options").find(option => {
          let pattern = option && option.get("pattern") && option.get("pattern").toLowerCase();
          const patternSplit = pattern && pattern.split(",");
          pattern = patternSplit && patternSplit.sort();
          pattern = pattern && pattern.join(",");

          let propertyTickers = propertyTickersString.toLowerCase();
          const propertyTickersSplit = propertyTickers.split(",");
          propertyTickers = propertyTickersSplit && propertyTickersSplit.sort();
          propertyTickers = propertyTickers && propertyTickers.join(",");

          return pattern === propertyTickers;
        });
      }
      if (result[constants.PROPERTY_FILTER.HOTEL_FILTER]) {
        optionByDefault = {
          [constants.PROPERTY_FILTER.HOTEL_FILTER]: result[
            constants.PROPERTY_FILTER.HOTEL_FILTER
          ].get("pattern"),
          name: result[constants.PROPERTY_FILTER.HOTEL_FILTER].get("optionName"),
          optionTicker: result[constants.PROPERTY_FILTER.HOTEL_FILTER].get("optionTicker"),
        };
      }
    }

    if (activeFilters || propertyTickersString) {
      setSelectedFilterValue(optionByDefault);
      setEstablishmentFilter(
        establishmentFilters && establishmentFilters.size && establishmentFilters.toJS()[0]
      );
      setFilterData(
        establishmentFilters && establishmentFilters.size && establishmentFilters.toJS()[0]
      );
    }
    return result;
  }

  useEffect(() => {
    const logo = logos.get("logo").get("url");
    const logoMobile = logos.get("logoMobile") && logos.get("logoMobile").get("url");
    setLogo(logo);
    setLogoMobile(logoMobile || logo);
  }, [logos]);

  function submitForm(form) {
    bookingFormChanged({ ...form });
    submitBookingForm({
      bookingForm: {
        ...bookingFormInitialValues,
        ...form,
      },
      bookingFormFields,
      locale,
      globalPropertyTicker,
      addAlert,
      formValues: {
        ...bookingFormInitialValues,
        ...form,
      },
      push,
      requestARI,
      ...bookingFormInitialValues,
      ...form,
      currentStep,
      propertyTickers: [selectedFilterValue.pattern],
      stay: form.stay,
      sessionId: restoredSession && restoredSession.id,
    });
    if (promoCodesValue !== undefined) {
      setPromoCodesValue("");
    }
    changeConfiguration({
      propertyTicker,
      configuration: { startDate: form.startDate, endDate: form.endDate },
    });
  }

  const handleSearchButton = useCallback(
    e => {
      e && e.preventDefault();
      if (showFilter) {
        submitFormSearchButton({
          modifiedForm: form,
          establishmentFilter,
          urlFilter,
          selectedFilterValue,
          propertyTicker,
        });
      } else {
        submitForm(form);
      }
    },
    [form, establishmentFilter, urlFilter, selectedFilterValue, showFilter]
  );

  const handleFilterChanged = useCallback(selectedFilterValue => {
    const { type, optionName: name, pattern } = selectedFilterValue;
    const establishmentFilterNew = { ...establishmentFilter };
    let urlFilter = {};
    switch (type) {
      case constants.PROPERTY_FILTER.TYPE.ESTABLISHMENT:
        establishmentFilterNew[constants.PROPERTY_FILTER.HOTEL_FILTER] =
          pattern && pattern.split(",");
        establishmentFilterNew.name = name;
        establishmentFilterNew.pattern = pattern;
        establishmentFilterNew.optionTicker = selectedFilterValue.optionTicker;
        setEstablishmentFilter(establishmentFilterNew);
        break;

      case constants.PROPERTY_FILTER.TYPE.URL:
        urlFilter = { url: pattern, name: name };
        setUrlFilter(urlFilter);
        break;

      default:
        break;
    }
    setSelectedFilterValue(selectedFilterValue);
    return {
      establishmentFilter: establishmentFilterNew,
      urlFilter,
    };
  }, []);

  function formatOccupantStay(occupants) {
    //Order for Stay: {"adults":1,"children":1,"seniors":0,"teenagers":0,"babies":0}
    return Object.keys(occupants).reduce((result, room) => {
      const occupantsByRoom = occupants[room];
      const adultPart = `${occupantsByRoom.ADULT?.value || 0}`;
      const hasAges = Boolean(
        Array.isArray(occupantsByRoom.CHILD?.guestAges) && occupantsByRoom.CHILD?.guestAges?.length
      );
      const nonAdultPart = hasAges
        ? `[${occupantsByRoom.CHILD?.guestAges.join(",")}]`
        : `,${(occupantsByRoom.CHILD && occupantsByRoom.CHILD.value) || 0},${
            (occupantsByRoom.SENIOR && occupantsByRoom.SENIOR.value) || 0
          },${(occupantsByRoom.TEENAGER && occupantsByRoom.TEENAGER.value) || 0},${
            (occupantsByRoom.BABY && occupantsByRoom.BABY.value) || 0
          }`;
      const roomWithOccupant = adultPart + nonAdultPart;
      return `${result}${result && result.length ? "&" : ""}stay=${roomWithOccupant}`;
    }, "");
  }

  const getOccupantsForm = useCallback(
    occupants => {
      const firstIndex = Object.keys(occupants)[0];
      const occupantsFirstRoom = occupants[firstIndex];
      return (
        occupantsFirstRoom &&
        Object.keys(occupantsFirstRoom).reduce((result, occupantType) => {
          const occupant = occupantsFirstRoom[occupantType];
          if (
            occupantType === constants.OCCUPANTS_TYPE.CHILDREN &&
            bookingFormFields.fields.childrenCount
          ) {
            result = {
              ...result,
              guestAges: occupant.guestAges.map(age => age.toString()),
              childrenCount: occupant.value.toString(),
            };
          }
          result = {
            ...result,
            [occupant.occupantType]: occupant.value.toString(),
          };
          return result;
        }, {})
      );
    },
    [bookingFormFields]
  );

  const getFormatedOccupant = useCallback(
    (selectedOccupants, modifiedForm) => {
      const roomsLength = Object.keys(selectedOccupants).length;
      const stayQueue = [];
      if ((showMultipleAccommodations || (stayQueue && stayQueue.length > 1)) && roomsLength > 1) {
        const stay = formatOccupantStay(selectedOccupants);
        modifiedForm = {
          stay,
          stayQueue: selectedOccupants,
        };
      } else {
        modifiedForm = {
          stay: "",
          stayQueue: null,
        };
        removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE);
        removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE_INDEX);
        removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE_DATE_IN);
        removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE_DATE_OUT);
      }
      const occupants = getOccupantsForm(selectedOccupants);
      setOccupantInfo(selectedOccupants);
      modifiedForm = {
        ...modifiedForm,
        ...occupants,
        occupants,
      };

      return modifiedForm;
    },
    [showMultipleAccommodations, getOccupantsForm]
  );

  const handleOccupantsChanged = useCallback(
    (selectedOccupants = {}, isSubmit) => {
      let newForm = {
        ...form,
        ...getFormatedOccupant(selectedOccupants, form),
      };
      if (isSubmit) {
        if (showFilter) {
          submitFormSearchButton({
            modifiedForm: newForm,
            establishmentFilter,
            urlFilter,
            selectedFilterValue,
            propertyTicker,
          });
        } else {
          submitForm(newForm);
        }
      } else {
        setForm(newForm);
      }
    },
    [form, showFilter, establishmentFilter, urlFilter, selectedFilterValue]
  );

  const handleDatesChanged = useCallback(
    ({ startDate, endDate }, isSubmit) => {
      const modifiedForm = {
        ...form,
        startDate,
        endDate,
      };
      if (isSubmit && deviceType !== constants.DEVICE_TYPE.MOBILE) {
        if (showFilter) {
          submitFormSearchButton({
            modifiedForm,
            establishmentFilter,
            urlFilter,
            selectedFilterValue,
            propertyTicker,
          });
        } else {
          submitForm(modifiedForm);
        }
      } else {
        setForm(modifiedForm);
      }
    },
    [showFilter, deviceType, form, establishmentFilter, urlFilter, selectedFilterValue]
  );

  function handleSearchMobile(occupants, dates, selectedFilter, promoCodes) {
    const { startDate, endDate } = dates;
    const modifiedForm = {
      ...form,
      startDate,
      endDate,
      promoCodes: [form && form.promoCodes, promoCodes].filter(Boolean).join(","),
      ...getFormatedOccupant(occupants, modifiedForm),
    };
    setForm(modifiedForm);

    if (showFilter) {
      const { establishmentFilter, urlFilter } = handleFilterChanged(selectedFilter);
      submitFormSearchButton({
        modifiedForm,
        establishmentFilter,
        urlFilter,
        selectedFilterValue: selectedFilter,
        propertyTicker,
      });
    } else {
      submitForm(modifiedForm);
    }
  }

  function handleCodeChanged(e) {
    let promoCodes = e.target.value;
    setPromoCodesValue(promoCodes);
    if (bookingFormInitialValues.promoCodes && get(restoredSession, "promoCodes", false)) {
      promoCodes = `${bookingFormInitialValues.promoCodes},${promoCodes}`;
    }
    setPromoCodes(promoCodes);
    const modifiedForm = {
      ...form,
      promoCodes,
    };
    setForm(modifiedForm);
  }

  function handleOpenExternalMenuModal(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (isWithotel && window.self !== window.top) {
      window.parent.postMessage({ eventType: "handleMenu", action: "open" }, "*");
      return;
    }

    const modalOptions = {
      styles: {
        backgroundColor: "#616161",
        width: "90%",
        maxWidth: 500,
        boxShadow: "0px 0px 14px 2px rgba(0,0,0,0.75)",
        "margin-top": "-1px",
      },
    };

    const defaultMenu = (
      <DefaultMenu>
        {logos && (
          <DefaultMenuLogo>
            <a href={hotelSiteURL} target="_blank">
              <ImageMenuLogo src={logos.get("logo").get("url")} />
            </a>
          </DefaultMenuLogo>
        )}
        <div>Aquí iría el menú web del hotel / Here goes the hotels web menu</div>
      </DefaultMenu>
    );

    const menu =
      (menuMarkup && <div dangerouslySetInnerHTML={renderHTML(menuMarkup.get("code"))} />) ||
      defaultMenu;

    handleModalContent(menu, {
      className: "wbkv9-Modal-MarkupMenu",
      options: modalOptions,
      mobileMode: true,
    });
  }

  const handleLogOut = useCallback(async () => {
    if (session) {
      const { session: sessionData, removeSessionData } = session;
      const logoutUrl = `/api/loyalty/${brand.ticker}/session/${sessionData.id}`;
      try {
        const response = await axios.delete(logoutUrl);
        if (response.status === 200) {
          removeFromLocalStorage(constants.LOCAL_STORAGE_KEYS.SESSION_ID);
          removeSessionData();
          history.push(`/${params.hotelTicker}/${constants.STEP_PATHS.STEP_1}`);
        } else {
          console.error("Failed to logout.");
        }
      } catch (error) {
        console.error("Failed to logout, ", error);
      }
    }
  }, [brand, loyaltyUser, history, location, session]);

  const isGiftCardAffiliate = affiliate === "giftcard";

  if (isLoading) {
    return <> </>;
  }

  return (
    <BookingForm
      textNoOptions={<FormattedMessage {...msgs.textNoOption} />}
      addPaddingToLogo={addPaddingToLogo}
      element={element}
      filterData={filterData}
      hotelSiteURL={hotelSiteURL}
      logoSrc={deviceType === constants.DEVICE_TYPE.MOBILE ? logoMobile : logo}
      occupantInfo={occupantInfo}
      onPromoCodeChanged={handleCodeChanged}
      onDatesChanged={handleDatesChanged}
      onFilterChanged={handleFilterChanged}
      onOccupantsChanged={handleOccupantsChanged}
      onSearchButtonClicked={handleSearchButton}
      onSendSearchValue={handleSearchMobile}
      onOpenExternalMenu={handleOpenExternalMenuModal}
      promoCodes={promoCodesValue !== undefined ? promoCodesValue : promoCodes}
      resolution={resolution}
      roomDenomination={roomDenomination}
      selectedFilterValue={selectedFilterValue}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
      selectorMode={selectorMode}
      showFilter={!isGiftCardAffiliate && showFilter}
      showMenuOption={showMenuMarkup}
      showMobileLogo={showElementsConfig.showMobileLogo}
      showDesktopLogo={showElementsConfig.showDesktopLogo}
      showMultipleAccommodations={showMultipleAccommodations}
      isBookingFormSummaryOpened={isBookingFormSummaryOpened}
      toggleBookingFormSummary={toggleBookingFormSummary}
      loyaltyUser={loyaltyUser}
      showLoginLoyalty={brand}
      loyalty={loyalty}
      linkToLogin={linkToLogin}
      linkToSignUp={linkToLogin}
      onLogOut={handleLogOut}
      hidePromoCode={promoCode === constants.SHOW_PROMO_CODE.HIDE}
      openPromoCode={promoCode === constants.SHOW_PROMO_CODE.EXPANDED}
      history={history}
      params={params}
      handleCloseModal={handleCloseModal}
      handleModalContent={handleModalContent}
      showBackArrow={showBackArrow}
      myAccountClicked={myAccountClicked}
      myReservationsClicked={myReservationsClicked}
    />
  );
}
export default connect(createStructuredSelector({}), dispatch =>
  bindActionCreators({ ...appActions, ...bookingFormActions }, dispatch)
)(withRouter(BookingFormWrapper));
